import { ChangeDetectionStrategy, Component, Injector } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ComponentStore } from "@ngrx/component-store";
import { Store } from "@ngrx/store";
import {
  app_mst_role_RowClass,
  bl_applet_client_side_perm_dfn_RowClass,
  ClientSidePermissionRoleLinkContainerModel,
  ClientSidePermissionService,
  ClientSideTenantPermissionService,
  Pagination,
  TeamService,
  TenantRoleService,
} from "blg-akaun-ts-lib";
import { ToastrService } from "ngx-toastr";
import { SubSink } from "subsink2";
import { PermissionSetModel } from "../../../../../models/perm-set.model";
import { PermissionFacade } from "../../../../../modules/permission/facades/permission.facade";
import { ViewColumnComponent } from "../../../../../view-column.component";
import { AppConfig } from "../../../../../visa";
import { ClientSidePermissionStates } from "../../../../permission/client-side-permissions-controller/states";
import { ClientSidePermissionsActions } from "../../../client-side-permissions-controller/actions";
import { TranslateService } from "@ngx-translate/core";

interface LocalState {
  deactivateReturn: boolean;
}

@Component({
  selector: "app-client-side-permission-add",
  templateUrl: "./client-side-permission-add.component.html",
  styleUrls: ["./client-side-permission-add.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ComponentStore],
})
export class ClientSidePermissionAddComponent extends ViewColumnComponent {
  protected readonly index = 1;
  private localState: LocalState;

  readonly localState$ = this.viewColFacade.selectLocalState(this.index);
  readonly deactivateReturn$ = this.componentStore.select(
    (state) => state.localState.deactivateReturn
  );

  prevIndex: number;
  private prevLocalState: any;

  apiVisa = AppConfig.apiVisa;
  masterVisa = AppConfig.masterVisa;

  public form: FormGroup;

  // keep track of form being enabled/disabled
  formDisabled: boolean = false;

  // no leakage of subscribe calls
  private subSink = new SubSink();

  // fields that require options
  newRoleArr: app_mst_role_RowClass[] = [];
  roleArr: app_mst_role_RowClass[] = [];
  newClientPermArr: bl_applet_client_side_perm_dfn_RowClass[] = [];
  clientPermArr: bl_applet_client_side_perm_dfn_RowClass[] = [];

  // perm templates
  permTemplateArr = [];
  newPermTemplateArr = [];

  appletGuid: string = sessionStorage.getItem("appletGuid");
  newPermSet: PermissionSetModel;

  //translation variable
  title: string;
  client_side_permission_text: string;
  select_permission_text: string;
  invalid_entry: string;
  back_button: string;
  role_text: string;
  select_role_text: string;
  save_button: string;

  constructor(
    private clientSidePermissionService: ClientSidePermissionService,
    private tenantClientSidePermissionService: ClientSideTenantPermissionService,
    private teamService: TeamService,
    private toasterService: ToastrService,
    private tenantRoleService: TenantRoleService,
    private fb: FormBuilder,
    private viewColFacade: PermissionFacade,
    private store: Store<ClientSidePermissionStates>,
    private readonly componentStore: ComponentStore<{ localState: LocalState }>,
    private injector: Injector
  ) {
    super();
    const translateService = this.injector.get(TranslateService, null);
    if (translateService) {
      translateService.get('labels').subscribe(res => {
        this.title = res.add_client_side_permission;
        this.role_text = res.role;
        this.select_role_text = res.select_role;
        this.client_side_permission_text = res.client_side_permission;
        this.select_permission_text = res.select_permission;
        this.invalid_entry = res.invalid_entry;
        this.save_button = res.save_button;
        this.back_button = res.back_button;
      });
    } else {
      this.title = 'Add Client Side Permission';
      this.role_text = 'Role';
      this.select_role_text = 'Select Role';
      this.client_side_permission_text = 'Client Side Permission';
      this.select_permission_text = 'Select Permission';
      this.invalid_entry = 'Not a valid entry';
      this.save_button = 'SAVE';
      this.back_button = 'Back';
    }
  }

  /**
   * Lifecycle method: Called when the component is first initialised.
   */
  ngOnInit(): void {
    this.subSink.sink = this.localState$.subscribe((a) => {
      this.localState = a;
      this.componentStore.setState({ localState: a });
    });
    this.subSink.sink = this.viewColFacade.prevIndex$.subscribe(
      (resolve) => (this.prevIndex = resolve)
    );
    this.subSink.sink = this.viewColFacade
      .prevLocalState$()
      .subscribe((resolve) => (this.prevLocalState = resolve));

    this.form = this.fb.group({
      role: null,
      clientPerm: null,
      currentRole: null,
      currClientPerm: null,
    });

    this.subSink.sink = this.tenantClientSidePermissionService
      .getByCriteria(
        new Pagination(null, 100, null, [
          { columnName: "applet_guid", value: this.appletGuid },
          { columnName: "orderBy", value: "updated_date" },
          { columnName: "order", value: "DESC" },
        ]),
        this.apiVisa
      )
      .subscribe((data) => {
        this.newClientPermArr = this.clientPermArr = data.data.map(
          (d) => d.bl_applet_client_side_perm_dfn
        );
        console.log(this.newClientPermArr);
      });
    this.subSink.sink = this.tenantRoleService.get(this.apiVisa).subscribe((res) => {
      this.newRoleArr = this.roleArr = res.data.map((d) => d.app_mst_role);
    });
  }

  /**
   * This function is called whe the user clicks on the save button.
   * This will dispatch an NgRx action to create a new permission set.
   *
   */
  onSubmit() {
    // const perm = new ClientSidePermissionTeamLinkContainer();

    let perm: ClientSidePermissionRoleLinkContainerModel =
    new ClientSidePermissionRoleLinkContainerModel();

    // let clientSidePermission: ClientSidePermissionContainerModel =
    //   new ClientSidePermissionContainerModel();

    perm.bl_applet_client_side_perm_to_role_link.applet_guid = this.appletGuid;
    perm.bl_applet_client_side_perm_to_role_link.role_guid =
      this.form.value.role;
    perm.bl_applet_client_side_perm_to_role_link.client_perm_guid =
      this.form.value.clientPerm;

    this.store.dispatch(
      ClientSidePermissionsActions.createClientSidePermInit({
        clientSidePerm: perm,
      })
    );

    // this.subSink.sink = this.tenantClientSidePermissionService
    //   .getByGuid(this.form.value.clientPerm, this.apiVisa)
    //   .subscribe(
    //     (response) => {
    //       this.store.dispatch(
    //         ClientSidePermissionsActions.createClientSidePermInit({
    //           clientSidePerm: perm,
    //         })
    //       );
    //     },
    //     (error) => {
    //       clientSidePermission.bl_applet_client_side_perm_dfn =
    //         this.clientPermArr.find(
    //           (i) => i.guid === this.form.value.clientPerm
    //         );
    //       this.store.dispatch(
    //         ClientSidePermissionsActions.createTenantClientSidePermInit({
    //           clientSidePerm: clientSidePermission,
    //         })
    //       );
    //       setTimeout(()=>{
    //         this.store.dispatch(
    //           ClientSidePermissionsActions.createClientSidePermInit({
    //             clientSidePerm: perm,
    //           })
    //         );
    //       },1000)
    //     }
    //   );
  }

  /**
   * Dynamically change the options of shown on the screen by applying this filter.
   *
   * @param filterValue the value that the user types onto the screen
   */
  applyRoleFilter(filterValue: string) {
    filterValue = filterValue.trim(); // remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.newRoleArr = this.roleArr.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  /**
   * Dynamically change the options of shown on the screen by applying this filter.
   *
   * @param filterValue the value that the user types onto the screen
   */
  applyPermFilter(filterValue: string) {
    filterValue = filterValue.trim(); // remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.newClientPermArr = this.clientPermArr.filter((option) =>
      option.perm_name.toLowerCase().includes(filterValue)
    );
  }

  /**
   * Return to the previous drawer/view column.
   */
  onReturn() {
    this.viewColFacade.updateInstance(this.prevIndex, {
      ...this.prevLocalState,
      deactivateAdd: false,
      deactivateList: false,
    });
    this.viewColFacade.onPrev(this.prevIndex);
  }

  onSelect(event) {
    console.log(event);
  }

  /**
   * Lifecycle method: Called when this component is destroyed.
   */
  ngOnDestroy() {
    this.viewColFacade.updateInstance(this.index, {
      ...this.localState,
    });
    this.subSink.unsubscribe();
  }
}
